import { ViewStream } from "spyne";
import { CardTraits } from "traits/card-traits";
import { NavigationTraits } from "traits/navigation-traits";

export class /*!-@-{replaceClassName}*/ PageCardView /*@-*/ extends ViewStream {
  constructor(props = {}) {
    props.tagName = "li";
    props.data.cardTitle = props.data.headline.toUpperCase();
    const { pageId } = props.data.linkDataset;
    props.traits = [CardTraits, NavigationTraits];
    props.class = `page-card page-${pageId}-card`;

    props.template = require("./templates/page-cards.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_APP_ROUTE_CARD_CROSSFADE_EVENT", "onRouteCrossFadeEvent"],
      ["CHANNEL_APP_ROUTE_CARD_MINIMIZE_EVENT", "onRouteMinimizeEvent"],
      ["CHANNEL_APP_ROUTE_.*_CHANGE_EVENT", "onRouteChangeEvent"],
      ["CHANNEL_UI_ANIMATIONEND_EVENT", "onAnimationEnd"],
      ["CHANNEL_UI_CONTEXTMENU_EVENT", "onRightClick"],
    ];
  }

  onRightClick(e) {
    const a$ = this.props.el$("a.expand-card");
    if (this.isLocalEvent(e)) {
      a$.addClass("reveal");
      a$.el.focus();
    } else {
      a$.removeClass("reveal");
      a$.el.blur();
    }
  }

  onAnimationEnd(e) {
    if (this.isLocalEvent(e)) {
      const { event } = e;
      const { animationName } = event;

      let animDefaultFn = () => {
        //console.log('default anim event', animationName);
      };
      const animHash = {
        cardMaxAnim: this.card$ExpandAnimationComplete,
        cardMaxAnimReverse: this.card$MinimizeComplete,
      };

      const animFn = animHash[animationName] || animDefaultFn;
      requestAnimationFrame(animFn);
    }
  }

  onRouteCrossFadeEvent(e) {
    const { payload } = e;
    const { routeData, cardState, previousCardId } = payload;
    const { cardId } = routeData;

    const cardIdCurrent = this.props.data.cardId;
    const isExpanded = this.props.el$(".card-container.expanded").exists;

    if (cardIdCurrent === cardId) {
      const onFrame = () => this.card$ExpandAnimation(true, cardState);
      requestAnimationFrame(onFrame);
    } else if (cardId === previousCardId && isExpanded) {
      const onFrameMin = () => {
        this.card$MinimizeAnimation(true);
        this.props.el$.addClass("hide-card");
        this.nav$HideNav(true);
      };
      requestAnimationFrame(onFrameMin);
    }
  }

  onRouteMinimizeEvent(e) {
    const isExpanded = this.props.el$(".card-container.expanded").exists;
    if (isExpanded) {
      this.card$MinimizeAnimation();
    } else {
      this.card$UnhideCard();
      this.nav$HideNav(false);
    }
  }

  onRouteChangeEvent(e) {
    const { payload } = e;
    const { routeData, cardState } = payload;
    const { cardId } = routeData;
    const cardIdCurrent = this.props.data.cardId;
    const expandCard = cardIdCurrent === cardId;
    const disableAnim = ["reveal", "crossFade"].includes(cardState);

    if (expandCard) {
      this.card$ExpandAnimation(disableAnim);
    } else {
      const hideCardBool = this.card$ToggleHideCard(cardId);
      this.props.el$.toggleClass("hide-card", hideCardBool);
      this.nav$HideNav(hideCardBool);
    }
  }

  broadcastEvents() {
    // return nexted array(s)
    return [
      [".card-image", "click"],
      [".card-text", "click"],
      ["a.expand-card", "click"],
      [".back-btn-top", "click"],
      ["div.article", "contextmenu"],
      [".card-material", "animationend"],
    ];
  }

  onRendered() {
    this.addChannel("CHANNEL_APP_ROUTE");
    this.addChannel("CHANNEL_UI");
  }
}
